import Nav from '../../components/breadcrumb';
import PageHeader, { ActionBar, ActionButton, Title } from '../../components/pageheader';
import { Form, Table, Card, Row, Col, Button } from 'react-bootstrap';
import { SortButton } from '../../components/btns';
import { useState, useEffect } from 'react';
import PagePagination, { usePagination } from '../../components/pagination';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useScreenType } from '../../components/custom-hooks';
import { ErrorLoading, PageLoading } from '../../components/loading';
import { getRefuels } from '../../resources/api/refuels';
import cur from '../../components/currency';
import RefuelForm from './refuel-form';


const form_defaults = {
    station: "",
    refuel_date: "",
    no_litres: "",
    unit_cost: "",
    total_cost: "",
    account_id: "",
    method: "",
    odometer_reading: ""
}


/**
 * View table items on screens larger than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/refuels').RefuelObject[]
 * currentPage: number
 * noPageItems: number
 * }} param0 
 */
const ViewDesktop = ({ srt, handleSort, items, currentPage, noPageItems, onClickEdit }) => {
    return (
        <Table responsive hover style={{ minWidth: '700px' }}>
            {/* <colgroup>
                <col span="1" style={{ width: "3%" }} />
                <col span="1" style={{ width: "17%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
            </colgroup> */}
            <thead>
                <tr>
                    <th>#</th>
                    <th>Date <SortButton field="refuel_date" {...srt} handleSort={handleSort} /></th>
                    <th>Station <SortButton field="station" {...srt} handleSort={handleSort} /></th>
                    <th className='text-end'>Mileage <SortButton field="odometer_reading" {...srt} handleSort={handleSort} /></th>
                    <th>No Litres <SortButton field="no_litres" {...srt} handleSort={handleSort} /></th>
                    <th style={{ textAlign: 'right' }}>Rate <SortButton field="unit_cost" {...srt} handleSort={handleSort} /></th>
                    <th style={{ textAlign: 'right' }}>Total <SortButton field="total_cost" {...srt} handleSort={handleSort} /></th>
                    <th>...</th>
                </tr>

            </thead>
            <tbody>
                {items.map((e, i) => (
                    <tr key={i}>
                        <td>{(currentPage - 1) * noPageItems + i + 1}</td>
                        <td>{moment(e.refuel_date).format("DD MMM YYYY")}</td>
                        <td>{e.station}</td>
                        <td className='text-end'>{cur(e.odometer_reading, 0).format()}</td>
                        <td>{e.no_litres}</td>
                        <td style={{ textAlign: 'right' }}>{cur(e.unit_cost, 0).format()}</td>
                        <td style={{ textAlign: 'right' }}>{cur(e.total_cost, 0).format()}</td>
                        <td>
                            <Button variant="link" size="sm" className='text-danger p-0 me-2' onClick={() => onClickEdit(e.id)}>
                                <i className="fas fa-pencil-alt" />
                            </Button>
                            <Button variant="link" size="sm" className='text-danger p-0 me-2' onClick={() => onClickEdit(e.id, 'expense')}>
                                <i className="fas fa-file-pen" />
                            </Button>
                            <Button as={Link} to={`/app/expenses/${e.expense_id}`} variant="link" size="sm" className='text-primary p-0'>
                                <i className="fas fa-eye" />
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table >
    )
}

/**
 * view items on screens smaller than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/refuels').RefuelObject[]
 * }} param0 
 */
const ViewMobile = ({ srt, handleSort, items, onClickEdit }) => {
    return (
        <div className="my-3">
            <div className="mb-3" style={{ whiteSpace: 'nowrap', overflowX: 'auto', maxWidth: '100%' }}>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Date <SortButton field="refuel_date" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Station <SortButton field="station" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    No Litres <SortButton field="no_litres" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Rate <SortButton field="unit_cost" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Total <SortButton field="total_cost" {...srt} handleSort={handleSort} />
                </span>
            </div>
            {items.map((e, i) => (
                <Card className="my-2 shadow-sm" key={i}>
                    <Card.Body className="px-3">
                        <div>
                            <h4 className="h4 d-flex justify-content-between">
                                <span>{moment(e.refuel_date).format("DD MMM YYYY")}</span>
                                <span>
                                    <Button variant="link" size="sm" className='text-danger p-0 me-2' onClick={() => onClickEdit(e.id)}>
                                        <i className="fas fa-pencil-alt" />
                                    </Button>
                                    <Button variant="link" size="sm" className='text-danger p-0 me-2' onClick={() => onClickEdit(e.id, 'expense')}>
                                        <i className="fas fa-file-pen" />
                                    </Button>
                                    <Button as={Link} to={`/app/expenses/${e.expense_id}`} variant="link" size="sm" className="text-primary p-0">
                                        <i className="fas fa-eye" />
                                    </Button>
                                </span>

                            </h4>
                            <p className="mb-1"><i className='fas fa-location-crosshairs fa-fw me-1' /> {e.station}</p>
                            <p className="mb-1"><i className='fas fa-gauge-high fa-fw me-1' /> {cur(e.odometer_reading, 0).format()}</p>
                            <p className="mb-1"><i className='fas fa-hashtag fa-fw me-1' /> {e.no_litres}</p>
                            <p className="mb-1"><i className='fas fa-at fa-fw me-1' /> {cur(e.unit_cost, 0).format()}</p>
                            <p className="mb-1"><i className='fas fa-receipt fa-fw me-1' /> {cur(e.total_cost, 0).format()}</p>
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </div>
    )
}


/**
 * 
 * @param {Object} props 
 * @param {import('../../resources/api/vehicles').VehicleObject} props.details
 * @returns 
 */
const ViewRefuels = ({ details }) => {

    const nav_items = [
        { title: 'Vehicles', href: '/app/vehicles' },
        { title: details.reg_no, href: `/app/vehicles/${details.id}` },
        { title: 'Refuels' }
    ];

    const [srt, setSrt] = useState({
        currentField: 'refuel_date',
        currentOrder: 'desc'
    });

    const [noPageItems, setNoPageItems] = useState(10);
    const [displayItems, setDisplayItems] = useState([]);
    const [items, setItems] = useState([]);
    const [orginalItems, setOriginalItems] = useState([]);
    const [search, setSearch] = useState({ val: '', field: 'station' });

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState();

    const screenType = useScreenType();
    const [PAGE, NOPAGES, setPage] = usePagination(items.length, noPageItems);

    const [show, setShow] = useState(false);
    const [edit_action, setEditAction] = useState("create");

    const [refuelDetails, setRefuelDetails] = useState(form_defaults);


    const onClickEdit = (id, type = "refuel") => {
        let details = orginalItems.find(i => i.id === id);
        setRefuelDetails(details);
        setEditAction(type || "refuel");
        setShow(true);
    }

    const onClickNew = () => {
        setRefuelDetails(form_defaults);
        setEditAction("create");
        setShow(true);
    }

    const onUploadRefuel = details => {
        if (edit_action === "create") {
            setOriginalItems(items => items.concat(details));
        } else {
            let items = [...orginalItems];

            items.splice(
                items.findIndex(i => i.id === refuelDetails.id),
                1,
                details
            );
            setOriginalItems(items);
        }
    }




    /**
     * whenever the page changes, scroll back to the top of the list.
     */
    useEffect(() => {
        if (PAGE === 1) return;
        window.scrollTo({ top: 100, behavior: "smooth" });
    }, [PAGE])

    /**
     * whenever the value and field change ie. a search, 
     * filter the items and view on the page.
     */
    useEffect(() => {
        const v = search.val, f = search.field;
        if (v.length < 2 || f === "") return setItems(orginalItems);
        setItems([...orginalItems.filter(i => i[f].toLowerCase().indexOf(v.toLowerCase()) !== -1)]);
    }, [search.val, search.field, orginalItems]);


    /**
     * get the items
     */
    useEffect(() => {

        getRefuels({ vehicle_id: details.id })
            .then(({ refuels }) => {
                setOriginalItems(refuels);
                setItems(refuels);
            })
            .catch(e => setError(e))
            .finally(() => setLoaded(true))

    }, [details.id])


    /**
     * Update display items whenever 
     * (1) => the page changes 
     * (2) => the number of items a page changes 
     * (3) => items change in any way
     */
    useEffect(() => {

        const ditems = [],
            start = (PAGE * noPageItems) - noPageItems,
            end = (PAGE * noPageItems) > items.length ? items.length : PAGE * noPageItems;

        for (let index = start; index < end; index++) {
            ditems.push(items[index]);
        }

        setDisplayItems(ditems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PAGE, noPageItems, JSON.stringify(items)])

    /**
     * Is triggered when 
     * (1) => user has changed the sort field
     * (2) => user has changed sort order
     * (3) => user has changed length of items (i.e., there are new items in the page)
     */
    useEffect(() => {

        const comp = (a, b) => {
            if (srt.currentOrder === 'asc') {
                return (a[srt.currentField] > b[srt.currentField]) ? 1 : ((a[srt.currentField] < b[srt.currentField]) ? -1 : 0);
            }
            return (a[srt.currentField] < b[srt.currentField]) ? 1 : ((a[srt.currentField] > b[srt.currentField]) ? -1 : 0);
        }

        setItems(items => [...items].sort(comp));

    }, [srt.currentField, srt.currentOrder, items.length])

    /**
     * handle when someone clicks the sort button
     * @param {string} field 
     */
    const handleSort = field => {
        if (field === srt.currentField) {
            setSrt(d => ({ ...d, currentOrder: d.currentOrder === 'asc' ? 'desc' : 'asc' }));
        } else {
            setSrt(d => ({ currentField: field, currentOrder: 'asc' }));
        }
    }

    if (!loaded) return <PageLoading>Loading all fuel records...</PageLoading>;

    if (error) return <ErrorLoading>{error}</ErrorLoading>;


    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="1000">
                <Title>Vehicle Refuels</Title>
                <ActionBar>
                    <ActionButton onClick={onClickNew}>
                        <i className='fas fa-plus-circle me-2' />New Refuel
                    </ActionButton>
                </ActionBar>
            </PageHeader>

            <div className="max-1000">

                <Row xs={{ cols: "auto" }} className="align-items-center justify-content-md-end mb-3 flex-nowrap g-0">
                    <Col>

                        <Form.Control placeholder="Search For" size="sm"
                            value={search.val}
                            onChange={e => setSearch({ ...search, val: e.currentTarget.value })}
                        />
                    </Col>
                    <Col>
                        <span className="mx-1">in</span>
                    </Col>
                    <Col>
                        <Form.Select as="select" size="sm"
                            value={search.field}
                            onChange={e => setSearch({ ...search, field: e.currentTarget.value })}
                        >
                            <option value="station">Station</option>
                        </Form.Select>
                    </Col>

                </Row>

                {screenType === 'desktop' ?
                    <ViewDesktop
                        srt={srt}
                        handleSort={handleSort}
                        items={displayItems}
                        noPageItems={noPageItems}
                        currentPage={PAGE}
                        onClickEdit={onClickEdit}
                    /> :
                    <ViewMobile
                        srt={srt}
                        handleSort={handleSort}
                        items={displayItems}
                        onClickEdit={onClickEdit}
                    />
                }

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Row xs={{ cols: "auto" }} className="align-items-center g-0 flex-nowrap mb-2">

                        <Col className="me-2 text-nowrap">No Items:</Col>
                        <Col>
                            <Form.Select
                                value={noPageItems}
                                onChange={e => setNoPageItems(parseInt(e.currentTarget.value))}
                                size="sm"
                                style={{ maxWidth: '100px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Select>
                        </Col>

                        <Col className="ms-2 text-nowrap">{items.length} of {orginalItems.length}</Col>
                    </Row>
                    <PagePagination
                        page={PAGE}
                        no_pages={NOPAGES}
                        setPage={setPage}
                    />
                </div>
            </div>

            <RefuelForm
                refuelDetails={{ details: refuelDetails, setDetails: setRefuelDetails }}
                action={edit_action}
                show={{ show, setShow }}
                onUpload={onUploadRefuel}
                vehicle_id={details.id}
            />

        </>
    )
}


export default ViewRefuels;